<template>
    <RegisterUser 
    :redirect="redirect" 
    @signed="val => val===AccountType.SPRING ? stage=RegisterStages.SPRING_2FA : stage=RegisterStages.SUMMER_2FA"
    @verified_twofa="val => val===AccountType.SPRING ? stage=RegisterStages.SPRING_PAY : stage=RegisterStages.SUMMER_PAY"
    @nextStage="to => stage=to" @previousStage="stage=stageData[stage].previousStage" 
    :stage="stage" :stageData="stageData[stage]">
    </RegisterUser>
    <!-- <RegisterDummy></RegisterDummy> -->
</template>

<script setup lang="ts">
// import RegisterDummy from '@/components/appState/RegisterDummy.vue';
import { ref, onMounted, watch } from 'vue'
import { RegisterRedirects } from '@/store/state'
import { RegisterStageData, RegisterStages } from '../store/state'
import RegisterUser from '@/components/entries/RegisterUser.vue'
import { AccountType, useUserStore } from '@/store/userData'

const stage = ref<RegisterStages>(RegisterStages.OPTIONS)
const stageData: Record<RegisterStages, RegisterStageData> = {
    internship_options: {title: 'I want to prepare for', previousStage: RegisterStages.OPTIONS},
    spring_packs: {title: 'I want to prepare with', options: ['Spring', 'A custom prep-pack', 'A free trial'], previousStage: RegisterStages.OPTIONS},
    spring_build: {title: 'Build your prep-pack', previousStage: RegisterStages.SPRING_PACKS},
    summer_packs: {title: 'I want to prepare with', options: ['Summer/Grad', 'A custom prep-pack', 'A free trial'], previousStage: RegisterStages.OPTIONS},
    summer_build: {title: 'Build your prep-pack', previousStage: RegisterStages.SUMMER_PACKS},
    spring_form: {title: 'Sign up', previousStage: RegisterStages.SPRING_PACKS},
    summer_form: {title: 'Sign up', previousStage: RegisterStages.SUMMER_PACKS},
    spring_2fa: {title: '2-step verification', previousStage: RegisterStages.SPRING_FORM},
    summer_2fa: {title: '2-step verification', previousStage: RegisterStages.SUMMER_FORM},
    spring_pay: {title: "You're signed up", previousStage: RegisterStages.SPRING_FORM},
    summer_pay: {title: "You're signed up", previousStage: RegisterStages.SUMMER_FORM},
    pay_succeeded: {title: "", previousStage: RegisterStages.PAY_SUCCEDED},
    pay_failed: {title: "", previousStage: RegisterStages.PAY_FAILED},
    pack_upgrade: {title: "Upgrade your account", previousStage: RegisterStages.OPTIONS},
    build_upgrade: {title: "", previousStage: RegisterStages.OPTIONS},

    build_graduate: {title: "", previousStage: RegisterStages.OPTIONS},
    build_pay: {title: "", previousStage: RegisterStages.OPTIONS},
}

const redirect = ref<RegisterRedirects>(RegisterRedirects.NONE);
onMounted(async() => {
  const searchParams = new URLSearchParams(window.location.search)
  redirect.value = decodeURIComponent(searchParams.get("redirect") as string) as RegisterRedirects;

  switch (redirect.value) {
    case RegisterRedirects.PayAttempted:
      {
      const redirect_status_payments = searchParams.get("redirect_status")
      if (redirect_status_payments === 'succeeded') {
        stage.value = RegisterStages.PAY_SUCCEDED;
      } else {
        stage.value = RegisterStages.PAY_FAILED;
      }
      break;
      }
    case RegisterRedirects.BuiltSpring:
    {
    const encodedPack = searchParams.get("pack")
      const pack = encodedPack
        ? JSON.parse(decodeURIComponent(encodedPack))
        : [];
      localStorage.setItem('cached_pack', JSON.stringify(pack))
      stage.value = RegisterStages.SPRING_FORM;
      break;
    }

    case RegisterRedirects.BuiltSummer:
      {
      const encodedPack = searchParams.get("pack")
      const pack = encodedPack
        ? JSON.parse(decodeURIComponent(encodedPack))
        : [];
      localStorage.setItem('cached_pack', JSON.stringify(pack))
      stage.value = RegisterStages.SUMMER_FORM;
      break;
      }
    
    case RegisterRedirects.BuildUpgrade:
      {
        stage.value = RegisterStages.BUILD_UPGRADE;
        if (useUserStore().isLoggedIn) {
          stageData.spring_build.title = 'Upgrade your prep-pack';
          stageData.summer_build.title = 'Upgrade your prep-pack';
        }
        break;
      }

    case RegisterRedirects.UpgradeToPack:
      {
        stage.value = RegisterStages.PACK_UPGRADE;
        break;
      }

    case RegisterRedirects.ChoseSpring:
      stage.value = RegisterStages.SPRING_PACKS
      break;
    
    case RegisterRedirects.ChoseSummer:
      stage.value = RegisterStages.SUMMER_PACKS
      break;
    case RegisterRedirects.ChoseSpringPack:
      stage.value = RegisterStages.SPRING_FORM
      break;
    case RegisterRedirects.ChoseSummerPack:
      stage.value = RegisterStages.SUMMER_FORM
      break;
    // case RegisterRedirects.SeoSpringSignup:
    //   stage.value = RegisterStages.SPRING_FORM;
    //   break;
    // case RegisterRedirects.SeoSummerSignup:
    //   stage.value = RegisterStages.SUMMER_FORM;
    //   break;
    case RegisterRedirects.ChoseBuildGraduate:
      stage.value = RegisterStages.BUILD_GRADUATE
      break;
    case RegisterRedirects.ChosePackGraduate:
      stage.value = RegisterStages.PACK_GRADUATE;
      break;
    case RegisterRedirects.NONE:
      stage.value = RegisterStages.OPTIONS
  }
})

watch(stage, (newVal) => {
  if ((newVal === RegisterStages.SPRING_PAY || newVal === RegisterStages.SUMMER_PAY) && useUserStore().isLoggedIn) {
    stageData.spring_pay.title = "Finish upgrade";
    stageData.summer_pay.title = "Finish upgrade";
  }
})
</script>

<style scoped>
.sign {
    width: calc(100vw - 12px);
    position: relative;
    height: stretch;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    overflow: visible;
}
</style>